import React from 'react'
import {Typography} from 'antd'
import {PaymentMethodSettingPanelHeaderProps} from './props'
import styles from './styles.scss'
import {observer} from 'mobx-react'
import {
    STATUS_LABEL,
    TERMINAL_LABEL,
    TERMINAL_SETTINGS_TITLE
} from '@/constants/playwright-ids'

const {Title, Text} = Typography

export const PaymentMethodSettingPanelHeader: React.FC<PaymentMethodSettingPanelHeaderProps> = observer((
    {title, activeLabel, terminalsLabel}
) => {
    return (
        <>
            <Title level={4} data-test-id={TERMINAL_SETTINGS_TITLE}>
                {title}
            </Title>
            <Text data-test-id={TERMINAL_LABEL}>
                {terminalsLabel}
            </Text>&nbsp;
            <Text className={styles.subtitleSecondary} data-test-id={STATUS_LABEL}>
                {activeLabel}
            </Text>
        </>
    )
})
